import { gql } from '@apollo/client'

export const menuItems = gql`
  query MenuItems($menuType: MenuType!, $languageCode: String) {
    menuItems(menuType: $menuType, languageCode: $languageCode) {
      id
      key
      label
      shortLabel
      route
      icon
      sortOrder
      isActive
      requiredPermissions
      parentId
      metadata
      children {
        id
        key
        label
        shortLabel
        route
        icon
        sortOrder
        isActive
        requiredPermissions
      }
    }
  }
`
